import React, { useState } from 'react';
import { ChevronDown, Code, CreditCard, Building, TrendingUp, Users, DollarSign, Shield, CheckCircle, Menu, X } from 'lucide-react';
import Footer from './footer';
import Header from './header';
const PayXLanding = () => {
  const [activeTab, setActiveTab] = useState('banking');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'PARTNERING WITH ANVITECH', hasDropdown: true },
    { label: 'SOLUTIONS', hasDropdown: true },
    { label: 'DEVELOPERS', hasDropdown: false },
    { label: 'COMPANY', hasDropdown: true }
  ];

const features = [
  {
    icon: <Users className="w-8 h-8 text-blue-600" />,
    title: "Enhanced Customer Experience",
    description: "Deliver exceptional branded experiences that drive customer satisfaction and retention"
  },
  {
    icon: <DollarSign className="w-8 h-8 text-blue-400" />,
    title: "Cost Optimization & Revenue Growth",
    description: "Streamline operational expenses while identifying new revenue opportunities"
  },
  {
    icon: <Shield className="w-8 h-8 text-blue-900" />,
    title: "Regulatory Compliance Assurance",
    description: "Expert management of banking and healthcare regulations ensuring full compliance"
  },
  {
    icon: <Building className="w-8 h-8 text-blue-500" />,
    title: "Trusted Partnership Foundation",
    description: "Establish long-term credibility through secure, reliable, and robust financial solutions"
  }
];

  const services = [
    {
      id: 'banking',
      title: 'Banking and Ledgering',
      description: 'Integrate with foundational banking systems, banks, card processors, and more to quickly launch new banking and payment programs, including consumer-directed health (CDH) accounts like health savings accounts (HSAs) and flexible spending accounts (FSAs), directed spend accounts like healthy food and OTC stipends, reward accounts, loyalty accounts, and more.',
      icon: <Building className="w-6 h-6" />
    },
    {
      id: 'payments',
      title: 'Advanced Payment Processing',
      description: 'Streamline payment flows with advanced processing capabilities designed for healthcare and consumer finance applications.',
      icon: <CreditCard className="w-6 h-6" />
    },
    {
      id: 'ecommerce',
      title: 'E-commerce',
      description: 'Build seamless e-commerce experiences with integrated payment solutions tailored for healthcare marketplaces.',
      icon: <Code className="w-6 h-6" />
    },
    {
      id: 'investments',
      title: 'Investments',
      description: 'Enable investment and wealth management features within your healthcare financial ecosystem.',
      icon: <TrendingUp className="w-6 h-6" />
    }
  ];

  const apiFeatures = [
    'Onboarding support',
    'Access to Anvitech Admin Portal',
    'Ongoing program management support',
    'Optional customer service support'
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Header />

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item, index) => (
              <button key={index} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600">
                {item.label}
              </button>
            ))}
            {/* <button className="w-full bg-blue-600 text-white px-3 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors mt-4">
              CONTACT US
            </button> */}
          </div>
        </div>
      )}

      {/* Hero Section - Light */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              {/* <div className="mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  🎉 Anvitech Raises ₹27M to Revolutionize Healthcare Payments
                </span>
              </div> */}
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Build an experience that closes the gap between health and finance
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Anvitech APIs enable you to embed healthcare financial services into your platform. With one integration, enable your customers to save, pay, invest, and purchase healthcare products and services.
              </p>
              {/* <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors">
                CONTACT US
              </button> */}
            </div>
            <div className="relative">
              <video
                className="w-full h-auto rounded-2xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-300"

                autoPlay
                muted
                loop
                playsInline
                src="/Healthcare.mp4"

              >
                <source src="/path/to/your/video.mp4" type="video/mp4" />
                <source src="/path/to/your/video.webm" type="video/webm" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - Dark */}
     <section className="bg-gradient-to-br from-gray-900 to-blue-900  py-20">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
      <h2 className="text-4xl font-bold text-white mb-4">
        Explore What You Can Build with Anvitech
      </h2>
      <p className="text-xl text-gray-300">
        Our programmatic APIs make it easy for you to build one-of-a-kind healthcare financial experiences.
      </p>
    </div>

    <div className="flex flex-wrap justify-center gap-4 mb-12">
      {services.map((service) => (
        <button
          key={service.id}
          onClick={() => setActiveTab(service.id)}
          className={`px-6 py-3 rounded-lg font-medium transition-all ${
            activeTab === service.id
              ? 'bg-blue-600 text-white'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
          }`}
        >
          {service.title}
        </button>
      ))}
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      <div className="bg-gray-800 rounded-2xl p-4">
        <img 
          src="./bankingL.png" 
          alt="Banking Solution Dashboard" 
          className="w-full h-48 rounded-lg shadow-lg object-contain"
        />
      </div>
      <div className="text-white">
        <div className="flex items-center mb-4">
          <Building className="w-8 h-8 text-blue-400 mr-3" />
          <h3 className="text-2xl font-bold">
            {services.find(s => s.id === activeTab)?.title}
          </h3>
        </div>
        <p className="text-gray-300 text-lg leading-relaxed">
          {services.find(s => s.id === activeTab)?.description}
        </p>
      </div>
    </div>
  </div>
</section>

      {/* Features Section - Light */}
      <section className="bg-white py-20">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
      <h2 className="text-4xl font-bold text-gray-900 mb-4">
        Why Choose Anvitech Solutions
      </h2>
      <p className="text-lg text-gray-600 max-w-3xl mx-auto">
        Discover the advantages that set us apart in delivering exceptional software solutions
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {features.map((feature, index) => (
        <div key={index} className="text-center group">
          <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center group-hover:bg-blue-50 transition-colors">
            {feature.icon}
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">
            {feature.title}
          </h3>
          <p className="text-gray-600">
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* API Section - Dark */}
      <section className="bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Choose how you work with us
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-800 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">API Only</h3>
              <p className="text-gray-300 mb-8">
                Directly leverage Anvitech programmatic APIs to embed fintech solutions into your existing consumer experience. API Only access includes the following services:
              </p>
              <div className="space-y-4">
                {apiFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3" />
                    <span className="text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-blue-600 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">API+</h3>
              <p className="text-white mb-8">
                Get everything in API Only plus white-label consumer experiences, advanced analytics, and dedicated support for enterprise implementations.
              </p>
              <div className="space-y-4">
                {apiFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-blue-200 mr-3" />
                    <span className="text-white">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Light */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            Ready to own the experience?
          </h2>
          <a href="/Contact" className="">
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-medium text-lg hover:bg-blue-700 transition-colors">
              CONTACT US
            </button>
          </a>
        </div>
      </section>

      {/* Footer - Dark */}
      <Footer />
      {/* Mobile Menu Toggle */}
    </div>
  );
};

export default PayXLanding;